<template>
  <div class="product">
    <ProductCard v-if="teaser" :rate="rate" title="Commercial legal protection" />
    <ProductConfig v-else class="product-config" :rate="rate">
      <form>
        <div class="container-wrap">
          <AppSwitch id="legal-expenses-limit" value="true" disabled>
            <div slot="label">
              £100,000 limit for commercial legal protection is included
            </div>
            <p slot="help">
              This covers compensation awards, professional fees and legal costs associated with a range of legal
              disputes.
            </p>
          </AppSwitch>
        </div>
        <div v-if="showSelectOthers" class="text-center text-sm text-red-650">
          Must be purchased with at least 1 other cover
        </div>
      </form>
    </ProductConfig>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductCard from '@/components/products/Card.vue'
import ProductConfig from '@/components/products/Config.vue'
import AppSwitch from '@/components/products/form/Switch.vue'
import rateMixin from '@/mixins/rate'

export default {
  // filters: {},
  components: {
    ProductCard,
    ProductConfig,
    AppSwitch,
  },
  mixins: [rateMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  data () {
    if (this.teaser && !this.$store.getters.isCouponWithFreeLegalEntered) return {}

    const defaultRatingInputs = {
      id: 'LegalExpenses',
      key: 'LegalExpenses\\LegalExpenses',
      active: true,
      limit: '100000',
    }

    // overwrite defaults with what ratingEngine returns
    let ratingInputs = { ...defaultRatingInputs, ...this.rate.ratingInputs }

    // if there's a rate passed, overwrite default inputs
    const rate = this.getRate(this.rate.key)
    if (rate) ratingInputs = { ...ratingInputs, ...rate.ratingInputs }

    return {
      productKey: 'LegalExpenses',
      loading: false,
      form: {
        ...ratingInputs,
        // can't access this.getters here - need to access directly via $store
        productUuid: this.getAvailableProduct('LegalExpenses').id,
        turnover: this.$store.getters.getTurnover,
        hasOtherCover: !!this.$store.getters.getProducts.length,
        promocode: this.$store.getters.couponIds,
      },
    }
  },
  computed: {
    ...mapGetters(['isCouponWithFreeLegalEntered']),
    showSelectOthers () {
      const configuredProducts = this.$store.getters.getProducts
      if (!this.isCouponWithFreeLegalEntered) {
        if (configuredProducts.length < 1) return true
        if (configuredProducts.length === 1 && configuredProducts[0].key === 'LegalExpenses') return true
      }
      return false
    },
  },
  async mounted () {
    if (!this.teaser) return this.handleSubmit()

    // if coupon applied add product on List view
    if (this.isCouponWithFreeLegalEntered) {
      this.loading = true

      await this.handleSubmit()

      await this.$store.dispatch('updateQuote', this.$store.getters.getEstimate)

      this.$router.push('/products')
    }
  },
  methods: {
    validate () {
      return true
    },
    async handleSubmit () {
      // reset estimate if it has already been submitted for this rate
      this.$store.commit('updateEstimate', null)

      if (!this.validate()) {
        return
      }

      this.loading = true

      await this.updateRate(this.form)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false))
    },
  },
}
</script>
